import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { A } from '../../base';
import { colors } from '../../styles/theme';
import { Icon } from '../../ui_elements/icons';
import * as buttonVariants from './button-variants';

export const Button = styled('button')((props) => buttonVariants.buttonStyles(props));

Button.defaultProps = {
  variant: 'primary',
  size: 'medium',
  textTransform: 'uppercase',
  disabled: false,
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string
    ]))
  ]),
  variant: PropTypes.oneOf(['primary', 'secondary', 'transparent', 'disabled']),
  size: PropTypes.oneOf(['small', 'medium']),
  textTransform: PropTypes.oneOf(['uppercase', 'lowercase', 'none']),
  disabled: PropTypes.bool,
};

export const ButtonWithProgress = (props) => {
  const { children, disabled, loading } = props;

  // Drive the progress spinner from an explicit in-progress signal when the
  // caller passes `loading`; otherwise fall back to `disabled` for legacy
  // callers that only ever disable the button while an action is in flight.
  // Without this, a button disabled for a NON-progress reason (e.g. a
  // disconnected CMS integration in PushToCmsButton) renders a misleading
  // perpetual spinner — see eng-maintenance#21527.
  const showSpinner = loading !== undefined ? loading : disabled;

  return (
    <Button {...props} disabled={disabled}>
      {showSpinner ? (
        <>
          <Icon color={colors.white} role="status" type="spinner" spin="clockwise" withText />
          {children}
        </>
      ) : (
        <>{children}</>
      )}
    </Button>
  );
};

ButtonWithProgress.defaultProps = {
  disabled: false,
  onClick: () => undefined,
  children: null,
};

ButtonWithProgress.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  // When provided, controls the progress spinner independently of `disabled`.
  // When omitted, the spinner falls back to mirroring `disabled` (legacy behavior).
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export const SubmitButton = (props) => (
  <Button {...props} type="submit" onClick={() => {}} variant="primary">
    Submit
  </Button>
);

export const LinkButton = styled(A)`
  line-height: 1;
  display: inline-flex;
  text-transform: uppercase;
  ${(props) => buttonVariants[props.size]};
  & + button {
    margin-left: 5px;
  }
`;

LinkButton.defaultProps = {
  size: 'medium',
};

LinkButton.propTypes = {
  href: PropTypes.string,
  size: PropTypes.string,
};

export const CancelLinkButton = (props) => <LinkButton {...props}>Cancel</LinkButton>;
CancelLinkButton.defaultProps = {};
CancelLinkButton.propTypes = { href: PropTypes.string };
